import React, { Component } from "react";
import { Modal, Button, Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import Creatable from "react-select/lib/Creatable";
import DatePicker from "react-datepicker";
import { connect } from "react-redux";
import { buildOptions } from "../utils";
import withFetchHook from "../withFetchHook";
import { sendStaffAppMetaData } from "../staffApp/eventTriggers";

class OccupationFormModal extends Component {
  handleClose() {
    this.props.closeModal();
  }

  handleChange(name, value) {
    this.props.updateField(name, value);
  }

  updateResidentOccupations(occupation) {
    const { organizationName, resident } = this.props;

    return this.props.fetch(`/organizations/${organizationName}/residents/${resident.id}.json`, {
      method: "PATCH",
      headers: {'Content-Type': 'application/json'},
      data: JSON.stringify({
        resident: {
          occupations_attributes: [occupation]
        }
      })
    });
  }

  deleteOccupation() {
    const { occupation, deleteOccupation, closeModal, isStaffApp } = this.props;

    this.updateResidentOccupations({
      id: occupation.id,
      _destroy: true
    }).then(() => {
      deleteOccupation(occupation);
      if (isStaffApp) {
        alert("Occupation deleted successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  saveOccupation() {
    const { occupation, updateOccupations, closeModal, isStaffApp } = this.props;

    this.updateResidentOccupations(occupation).then((data) => {
      updateOccupations(data.occupations);
      if (isStaffApp) {
        alert("Occupation changes saved successfully.")
        this.setDefaultStaffAppMetaData()
      }
      closeModal();
    });
  }

  setDefaultStaffAppMetaData = () => sendStaffAppMetaData(this.props.tabDefaultMetaData)

  saveOccupationFunction = (e) => {
    this.props.dispatch(this.saveOccupation())
  }

  componentDidMount() {
    document.addEventListener("saveOccupation", this.saveOccupationFunction)
  }

  componentWillUnmount() {
    document.removeEventListener("saveOccupation", this.saveOccupationFunction)
  }

  render() {
    const {
      kind,
      employer,
      position,
      income,
      started_at,
      ended_at,
      notes
    } = this.props.occupation;
    const { isStaffApp, hasDelete, hasEdit } = this.props
    const kindOptions = buildOptions([
      "Full-time", "Part-time", "Unemployed", "Not in Labor Force",  "Homemaker",
      "Student", "Retired", "Disabled", "Inmate", "Not Applicable", "Volunteer", "Not Looking", "Internship"
    ]);
    const kindValue = kindOptions.find((option) => option.value === kind);

    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        {
          !isStaffApp &&
          <Modal.Header closeButton>
            <Modal.Title>Occupation</Modal.Title>
          </Modal.Header>
        }
       <Modal.Body className={hasEdit ? "" : "form-modal-width"}>
          {hasEdit ? (
            <>
              <Form.Group controlId="occupationKind">
                <Form.Label>Kind</Form.Label>
                <Creatable
                  options={kindOptions}
                  value={kindValue}
                  onChange={(option) => {
                    this.handleChange("kind", option.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="occupationEmployer">
                <Form.Label>Employer</Form.Label>
                <Form.Control
                  value={employer}
                  onChange={(e) => {
                    this.handleChange("employer", e.target.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="occupationPosition">
                <Form.Label>Position</Form.Label>
                <Form.Control
                  value={position}
                  onChange={(e) => {
                    this.handleChange("position", e.target.value);
                  }} />
              </Form.Group>
              <Form.Group controlId="occupationIncome">
                <Form.Label>Annual Income</Form.Label>
                <Form.Control
                  value={income}
                  onChange={(e) => {
                    this.handleChange("income", e.target.value);
                  }} />
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group controlId="occupationStartedAt">
                    <Form.Label>Started at</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={started_at ? moment(started_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "started_at",
                          date ? date.format("YYYY-MM-DD") : null
                        )
                      }} />
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group controlId="occupationEndedAt">
                    <Form.Label>Ended at</Form.Label>
                    <DatePicker
                      className="form-control"
                      selected={ended_at ? moment(ended_at) : null}
                      onChange={(date) => {
                        this.handleChange(
                          "ended_at",
                          date ? date.format("YYYY-MM-DD") : null
                        )
                      }} />
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group controlId="occupationNotes">
                <Form.Label>Notes</Form.Label>
                <Form.Control
                  as="textarea"
                  value={notes}
                  onChange={(e) => {
                    this.handleChange("notes", e.target.value);
                  }} />
              </Form.Group>
            </>
          ) : (
            <>
              <Form.Group>
                <Form.Label>Kind</Form.Label>
                <div className="form-control-plaintext">{kind || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Employer</Form.Label>
                <div className="form-control-plaintext">{employer || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Position</Form.Label>
                <div className="form-control-plaintext">{position || 'N/A'}</div>
              </Form.Group>
              <Form.Group>
                <Form.Label>Annual Income</Form.Label>
                <div className="form-control-plaintext">{income || 'N/A'}</div>
              </Form.Group>
              <Row>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Started at</Form.Label>
                    <div className="form-control-plaintext">{started_at ? moment(started_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
                <Col sm={6}>
                  <Form.Group>
                    <Form.Label>Ended at</Form.Label>
                    <div className="form-control-plaintext">{ended_at ? moment(ended_at).format('MM/DD/YYYY') : 'N/A'}</div>
                  </Form.Group>
                </Col>
              </Row>
              <Form.Group>
                <Form.Label>Notes</Form.Label>
                <div className="form-control-plaintext">{notes || 'N/A'}</div>
              </Form.Group>
            </>
          )}
        </Modal.Body>
        {
          !isStaffApp ? 
          <Modal.Footer>
            {
              this.props.action === "edit" && hasDelete &&
              <Button
                variant="outline-danger"
                onClick={() => {
                  const { occupation } = this.props;
                  this.deleteOccupation(occupation);
                }}>
                Delete
              </Button>
            }
            <Button
              variant="info"
              onClick={() => this.saveOccupation()}>
              {this.props.action === "edit" ? "Update" : "Create"}
            </Button>
          </Modal.Footer> :
          <>
            {
              this.props.action == 'edit' && hasDelete &&
              <div className="p-4">
                <Button
                  variant="outline-danger w-100"
                  onClick={() => {
                    const { occupation } = this.props;
                    this.deleteOccupation(occupation);
                  }}>
                  Delete
                </Button>
              </div>
            }
          </>
        }
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.occupationModal.show,
    occupation: state.ui.occupationModal.occupation,
    action: state.ui.occupationModal.action,
    organizationName: state.organization.name,
    resident: state.resident,
    isStaffApp: state.config.isStaffApp,
    resident_tabs: state.config.resident_tabs,
    config: state.config,
    tabDefaultMetaData: state.config.tab_default_meta_data.find(tab=> tab.detail == 'employment_history'),
    hasDelete: state.current_user.permissions.includes('Delete'),
    hasEdit: state.current_user.permissions.includes('Edit')
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => {
      dispatch({
        type: "CLOSE_RESOURCE_MODAL",
        payload: { resourceName: "occupation" }
      });
    },
    updateField: (name, value) => {
      dispatch({
        type: "UPDATE_RESOURCE_FIELD",
        payload: { resourceName: "occupation", name, value }
      });
    },
    updateOccupations: (occupations) => {
      dispatch({
        type: "UPDATE_OCCUPATIONS",
        payload: { occupations }
      });
    },
    createOccupation: (occupation) => {
      dispatch({
        type: "CREATE_OCCUPATION",
        payload: { occupation }
      });
    },
    deleteOccupation: (occupation) => {
      dispatch({
        type: "DELETE_OCCUPATION",
        payload: { occupation }
      })
    },
    dispatch: (func)=> dispatch(func()),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(OccupationFormModal));
